import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { SiteLayout } from "../components/site/SiteLayout";
import { Reveal } from "../lib/reveal";
import { useSeo } from "../lib/seo";
import { services } from "../lib/content";

const CAL_URL = process.env.REACT_APP_CAL_URL || "/contact";

export default function ServicesPage() {
  useSeo({
    title: "Agricultural Software Development Services",
    description:
      "Wald's four disciplines: digital transformation & legacy system modernization, agriculture AI solutions & automation, custom agricultural software, and agricultural cloud solutions — built for South African agricultural exporters and regulated operations.",
    path: "/services",
  });
  return (
    <SiteLayout>
      <section className="border-b border-border">
        <div className="container-wald py-20 md:py-28">
          <div className="eyebrow mb-6">Services</div>
          <h1 className="font-display text-4xl md:text-6xl leading-[1.02] tracking-tight max-w-4xl">
            Four disciplines. One operational spine.
          </h1>
          <p className="mt-6 max-w-2xl opacity-80 leading-relaxed text-lg">
            Engage Wald for one discipline, or bring us in as a full technology partner. Every engagement
            begins with discovery on your operation — not with a boilerplate proposal.
          </p>
        </div>
      </section>
      <section>
        <div className="container-wald py-20">
          <div className="border-t border-l border-border grid grid-cols-1 md:grid-cols-2">
            {services.map((s) => (
              <Reveal key={s.slug} className="border-b border-r border-border p-8 md:p-10">
                <Link to={`/services/${s.slug}`} data-testid={`services-list-${s.slug}`} className="block group">
                  <div className="flex items-center gap-4 mb-6">
                    <span className="font-mono-tab text-xs opacity-50">{s.number}</span>
                    <div className="h-px flex-1 bg-border" />
                  </div>
                  <h2 className="font-display text-2xl md:text-4xl mb-3 tracking-tight">{s.title}</h2>
                  <p className="opacity-90 mb-4 text-base md:text-lg">{s.tagline}</p>
                  <p className="text-sm opacity-70 leading-relaxed max-w-lg">{s.summary}</p>
                  <div className="mt-6 inline-flex items-center gap-1.5 copper-link text-sm">
                    Explore {s.title} <ArrowRight size={14} strokeWidth={2} />
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CTABlock />
    </SiteLayout>
  );
}

export function CTABlock() {
  return (
    <section className="border-t border-border bg-card">
      <div className="container-wald py-20">
        <div className="grid grid-cols-12 gap-8 items-end">
          <div className="col-span-12 md:col-span-8">
            <div className="eyebrow mb-4">Next step</div>
            <h2 className="font-display text-3xl md:text-5xl tracking-tight leading-[1.05] max-w-2xl">
              A 30-minute discovery call.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4 flex md:justify-end gap-3 flex-wrap">
            <a href={CAL_URL} target="_blank" rel="noreferrer noopener" data-testid="cta-block-cal" className="btn-copper">
              Book on Cal.com <ArrowUpRight size={14} strokeWidth={2} />
            </a>
            <Link to="/contact" data-testid="cta-block-contact" className="btn-outline">
              Contact form
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
